var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPersonAdd = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M6.667 3.333C7.402 3.333 8 3.931 8 4.667 8 5.402 7.402 6 6.667 6c-.736 0-1.334-.598-1.334-1.333 0-.736.598-1.334 1.334-1.334zm0 4c1.47 0 2.666-1.196 2.666-2.666C9.333 3.196 8.137 2 6.667 2 5.196 2 4 3.196 4 4.667c0 1.47 1.196 2.666 2.667 2.666zm0 1.334C4.094 8.667 2 10.76 2 13.333c0 .368.298.667.667.667.368 0 .666-.299.666-.667C3.333 11.495 4.83 10 6.667 10S10 11.495 10 13.333c0 .368.298.667.667.667.368 0 .666-.299.666-.667 0-2.573-2.094-4.666-4.666-4.666zM13.333 4H14c.367 0 .667.3.667.667 0 .366-.3.666-.667.666h-.667V6c0 .367-.3.667-.666.667-.367 0-.667-.3-.667-.667v-.667h-.667c-.366 0-.666-.3-.666-.666 0-.367.3-.667.666-.667H12v-.667c0-.366.3-.666.667-.666.366 0 .666.3.666.666V4z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPersonAdd, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/person-add.f11588c0.svg";
export { ForwardRef as ReactComponent };